import type { ReactNode, JSX} from "react";
import { Row } from "./Row";
import { Text } from "./Text";

export interface SidebarRightHeaderProps {
  readonly title: string;
  readonly closeButton?: ReactNode;
}

/**
 * Standard header for the right sidebar panel with title and close button.
 */
export function SidebarRightHeader({ title, closeButton }: SidebarRightHeaderProps): JSX.Element {
  return (
    <Row align="center" justify="between" className="w-full h-full">
      <Text variant="body" weight="semibold" as="span">{title}</Text>
      {closeButton}
    </Row>
  );
}
